import { createContext } from "react";

export interface Notification {
  message: string;
  severity: "success" | "error" | "warning" | "info";
  duration: number;
}

interface NotificationContextType {
  notify: (notification: Notification) => void;
}

export const NotificationContext = createContext<
  NotificationContextType | undefined
>(undefined);
